import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { CurrRates } from '../models/symbol-model';
import { DecimalPipe } from '@angular/common';
import { RateBoardMsgProps } from '../nxi-messages/msg-properties';
import { PershingTranslationService } from '@pershing/pershing-core';
@Component({
    selector: 'modern-currency-calculator',
    templateUrl: './modern-currency-calculator.component.html'
})
export class ModernCurrencyCalculatorComponent implements OnInit {
    @Input('currencyRates') currencyRates: Array<CurrRates>;
    @Input('lastCurrencyCaculatorStateIn') lastCurrencyCaculatorStateIn: any;
    // Save last state of currency calculator incase user in mobile mode and turn device.
    @Output() lastCurrencyCaculatorStateOut = new EventEmitter();
    public rateBoardMsg = RateBoardMsgProps;
    public currInput1: string;
    public currInput2: string;
    public selInput1: any;
    public selInput2: any;
    public locale: string;
    deviceType: any;
    selInput2Initial: string= "Please Choose Country";
    showCalculate: boolean = false;
    swapCurrencyCalculation : boolean = true;
    public tempselInput: any;
    constructor(
        private translationService: PershingTranslationService,
        private decimalPipe: DecimalPipe,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.locale = appSettings.locale;
        if(appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');
    }

    ngOnInit() {
        // Set calculator to prev state if one exists.
        if (this.lastCurrencyCaculatorStateIn && this.lastCurrencyCaculatorStateIn !== null) {
            this.currInput1 = this.lastCurrencyCaculatorStateIn.currInput1 ? this.lastCurrencyCaculatorStateIn.currInput1 : '';
            this.currInput2 = this.lastCurrencyCaculatorStateIn.currInput2 ? this.lastCurrencyCaculatorStateIn.currInput2 : '';
            this.selInput1 = this.lastCurrencyCaculatorStateIn.selInput1 ?
                this.currencyRates[this.findIndex(this.lastCurrencyCaculatorStateIn.selInput1)] : this.currencyRates[0];
            this.selInput2 = this.lastCurrencyCaculatorStateIn.selInput2 ?
                this.currencyRates[this.findIndex(this.lastCurrencyCaculatorStateIn.selInput2)] : this.currencyRates[3];
        } else {
            this.selInput2 = this.currencyRates[3]; // default to GBP
            this.currInput1 = "";
            this.currInput2 = "";
            this.selInput1 = this.currencyRates[0]; // default to USD
        }
    }

    ngOnDestroy(): void {
    }

    public convertCurrency() {
        let currString = this.currInput1;
        if ( (this.currInput1 === null || this.currInput1 === "") && this.currInput2 !== '') {
            currString = this.currInput2;
            this.swapCurrencyCalculation = true;
        } else if (this.currInput1 !== null ) {
            this.currInput2 = null;
            this.swapCurrencyCalculation = false;
        }
        if ( this.locale.includes('es')) {
            currString = currString.replace('.', '').replace(',', '.');
        }
        let input2;
        let curIp1 = parseFloat(currString.toString().replace(/,/g, ''));
        if (this.selInput1.fmtClosePrice > 0 && this.selInput2.fmtClosePrice > 0 && !Number.isNaN(curIp1)) {
            let selIp1 = parseFloat(this.selInput1.fmtClosePrice.toString());
            let selIp2 = parseFloat(this.selInput2.fmtClosePrice.toString());
            if ( this.swapCurrencyCalculation) {
                let selIp = selIp1;
                selIp1 =selIp2;
                selIp2 = selIp
            }
            if ((curIp1 * selIp2 / selIp1 < 1) && (curIp1 * selIp2 / selIp1 > -1)) {
                if (10000000 * curIp1 * selIp2 / selIp1 <= 2140000000) {
                    input2 = parseFloat(((10000000 * curIp1 * selIp2 / selIp1) / 10000000).toFixed(3));
                } else {
                    input2 = parseFloat(((10000000 * curIp1 * selIp2 / selIp1) / 100000).toFixed(3));
                }
            } else {
                input2 = parseFloat((curIp1 * selIp2 / selIp1).toFixed(3));
            }
            if (this.swapCurrencyCalculation) {
                this.currInput1 = this.decimalPipe.transform(input2, '1.3-3', this.locale);
            } else {
                this.currInput2 = this.decimalPipe.transform(input2, '1.3-3', this.locale);
            }
            
        } else {
            if (this.swapCurrencyCalculation ) {
                this.currInput1 = null;
            } else {
                this.currInput2 = null;   
            }
            console.log('Please fill the currency values...');
        }
        this.saveCurrentState();
    }

    findIndex(targetItem: any) {
        let targetItemSymbol = targetItem && !!targetItem.symbol ? targetItem.symbol.trim() : '';
        let index = this.currencyRates.findIndex(i => { return !!i.symbol && i.symbol.trim() === targetItemSymbol; });
        return index > 0 ? index : 0;
    }

    handleChange() {
        if (this.selInput2 !== "Please Choose Country" && ( this.currInput1 !== "" || this.currInput2!=="") ) {
            this.showCalculate = true;
        }
        this.saveCurrentState();
    }

    saveCurrentState() {
        this.lastCurrencyCaculatorStateOut.emit({
            currInput1: this.currInput1, currInput2: this.currInput2,
            selInput1: this.selInput1, selInput2: this.selInput2
        });
    }
    currencyInputChange(event: any): void {
        if (this.selInput2 !== "Please Choose Country" && ( this.currInput1 !== "" || this.currInput2!=="") ) {
            this.showCalculate = true;
        }
    }
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if ( charCode == 46) {
            return true;
        }
        else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
    }
}
